import { Suspense, lazy, useState } from 'react';
import { api, setToken } from '../api.js';

const LedgerSheet = lazy(() => import('../components/LedgerSheet.jsx'));

export function Auth({ onSignedIn, onForgot }) {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', practiceName: '', fullName: '' });
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      const r = mode === 'login'
        ? await api.post('/api/auth/login', { email: form.email, password: form.password })
        : await api.post('/api/auth/signup', form);
      setToken(r.token);
      onSignedIn();
    } catch (e2) { setErr(e2.message); } finally { setBusy(false); }
  };

  return (
    <div className="login">
      <Suspense fallback={null}><LedgerSheet /></Suspense>
      <form className="login__card" onSubmit={submit}>
        <h1 className="login__brand">Ledger</h1>
        <p className="login__tag">
          {mode === 'login'
            ? 'Multi-client accounting for South African practices.'
            : 'Set up your practice. You can add client companies once you are in.'}
        </p>

        {err && <div className="error">{err}</div>}

        {mode === 'signup' && (
          <>
            <label className="field"><span>Practice name</span>
              <input value={form.practiceName} onChange={set('practiceName')} required autoComplete="organization" /></label>
            <label className="field"><span>Your name</span>
              <input value={form.fullName} onChange={set('fullName')} required autoComplete="name" /></label>
          </>
        )}

        <label className="field"><span>Email</span>
          <input type="email" value={form.email} onChange={set('email')} required autoComplete="email" /></label>
        <label className="field"><span>Password</span>
          <input type="password" value={form.password} onChange={set('password')} required
                 autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
                 minLength={mode === 'signup' ? 12 : undefined} />
        </label>
        {mode === 'signup' && (
          <div style={{ fontSize: 12, color: 'var(--ink-faint)', marginTop: -8, marginBottom: 12 }}>
            At least 12 characters.
          </div>
        )}

        <button className="btn" type="submit" disabled={busy}>
          {busy ? 'Working' : mode === 'login' ? 'Sign in' : 'Create practice'}
        </button>

        {mode === 'login' && (
          <div style={{ marginTop: 12, fontSize: 13 }}>
            <button type="button" onClick={onForgot}
                    style={{ background: 'none', border: 0, padding: 0, font: 'inherit',
                             color: 'var(--debit)', textDecoration: 'underline', cursor: 'pointer' }}>
              Forgotten your password?
            </button>
          </div>
        )}

        <div className="login__switch">
          {mode === 'login' ? (
            <>New practice? <button type="button" onClick={() => { setMode('signup'); setErr(null); }}>Set one up</button></>
          ) : (
            <>Already registered? <button type="button" onClick={() => { setMode('login'); setErr(null); }}>Sign in</button></>
          )}
        </div>
      </form>
    </div>
  );
}
